import { IconButton } from "@mui/material";
import { History } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { getConsts } from "src/utils/consts";

type ProductHistoryProps = {
  sku: string;
};

export const ProductHistoryButton: React.FC<ProductHistoryProps> = ({ sku }: ProductHistoryProps) => {
  const history = useHistory();
  const consts = getConsts();

  const handleClick = () => {
    const productHistoryPath = `${consts.routerPath.productHistory}/${sku}`;
    history.push(productHistoryPath);
  };

  return (
    <IconButton onClick={handleClick}>
      <History />
    </IconButton>
  );
};
